import { render, staticRenderFns } from "./UserPasswordResetForm.vue?vue&type=template&id=6d174ddc"
import script from "./UserPasswordResetForm.vue?vue&type=script&lang=js"
export * from "./UserPasswordResetForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports